import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row popover-main" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPopover',
  setup(__props) {

const BasicPopover = defineAsyncComponent(() => import("@/components/theme/uikits/popover/BasicPopover.vue"))
const DirectionPopover = defineAsyncComponent(() => import("@/components/theme/uikits/popover/DirectionPopover.vue"))
const OffsetPopover = defineAsyncComponent(() => import("@/components/theme/uikits/popover/OffsetPopover.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      mains: "Popover",
      title: "Popover"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BasicPopover)),
        _createVNode(_unref(DirectionPopover)),
        _createVNode(_unref(OffsetPopover))
      ])
    ])
  ], 64))
}
}

})